import React, { Component } from 'react';
import { Button, message, Popconfirm } from 'antd';
import html2canvas from 'html2canvas';
import { connect } from 'react-redux';

import { BackBtn } from '@comm/BackBtn';
import {
  queryDeleteIncuStation,
  queryDisableIncuStation,
  queryEnableIncuStation,
  queryIncuStationConfig,
  queryIncuStationStatic,
  queryResetIncuStation,
  querySaveIncuStation,
  querySaveIncuStationConfig,
  queryUnitIncuStation,
} from '@api/incubator/station';
import ComSeatTable from './ComSeatTable';
import SeatAdd from './SeatAdd';
import SeatSet from './SeatSet';
import SeatUnit from './SeatUnit';
import SeatStatic from './SeatStatic';
import './seat.less';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addVisible: false,
      setVisible: false,
      unitVisible: false,
      deleteVisible: false,
      statisData: {},
      config: {},
      uuids: [], // 选中的工位集合
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.getStationConfig();
    this.getIncuStationStatic();
  }

  getIncuStationStatic = () => {
    queryIncuStationStatic({
      incubatorUuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          statisData: res.data,
        });
      }
    });
  };

  handleAdd = params => {
    const { seat } = params;
    querySaveIncuStation({
      ...seat,
      incubatorUuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handleAddVisible(false);
        this.seatTable.getIncuStationList();
      }
    });
  };

  handleDelete = params => {
    const { seat } = params;
    queryDeleteIncuStation({
      ...seat,
      incubatorUuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handleDeleteVisible(false);
        this.seatTable.getIncuStationList();
      } else {
        message.error(res.message);
      }
    });
  };

  handleEnable = () => {
    queryEnableIncuStation({
      uuids: this.state.uuids,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.seatTable.getIncuStationList();
      }
    });
  };

  handleDisable = () => {
    queryDisableIncuStation({
      uuids: this.state.uuids,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.seatTable.getIncuStationList();
      }
    });
  };

  handleReset = () => {
    queryResetIncuStation({
      uuids: this.state.uuids,
      incubatorUuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.seatTable.getIncuStationList();
      }
    });
  };

  getStationConfig = () => {
    queryIncuStationConfig({
      incubatorUuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          config: res.data,
        });
      }
    });
  };

  handleSet = params => {
    querySaveIncuStationConfig({
      ...params,
      incubatorUuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getStationConfig();
        this.handleSetVisible(false);
        this.seatTable.getIncuStationList();
      }
    });
  };

  handleUnit = params => {
    queryUnitIncuStation({
      ...params,
      uuids: this.state.uuids,
    }).then(res => {
      if (res.statusCode === 200) {
        this.handleUnitVisible(false);
        message.success(res.message);
        this.seatTable.getIncuStationList();
      } else {
        message.error(res.message);
      }
    });
  };

  handleAddVisible = flag => {
    this.setState({
      addVisible: !!flag,
    });
  };

  handleDeleteVisible = flag => {
    this.setState({
      deleteVisible: !!flag,
    });
  };

  handleSetVisible = flag => {
    this.setState({
      setVisible: !!flag,
    });
  };

  handleUnitVisible = flag => {
    this.setState({
      unitVisible: !!flag,
    });
  };

  createPic = () => {
    html2canvas(document.getElementById('seat-table')).then(canvas => {
      document.body.appendChild(canvas);
      this.convertCanvasToImage(canvas);
    });
  };

  convertCanvasToImage = canvas => {
    canvas.toBlob(blob => {
      const url = URL.createObjectURL(blob);
      const element = window.document.createElement('a');
      element.href = url;
      element.download = '工位';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    }, 'image/png');
  };

  handleChange = (uuids, price, disableLen) => {
    this.setState({
      uuids,
      disableLen,
    });
  };

  setOp = op => {
    this.setState({
      op,
    });
  };

  render() {
    const {
      addVisible,
      statisData,
      setVisible,
      deleteVisible,
      unitVisible,
      config,
      uuids,
      op,
      disableLen,
    } = this.state;
    const { accountInfo } = this.props;
    return (
      <div className="page-seat">
        <div style={{ marginBottom: 16 }}>
          <BackBtn />
        </div>
        <SeatStatic statisData={statisData} uuid={this.props.params.uuid} />
        <div className="seat-op" style={{ marginBottom: 16 }}>
          <Button
            icon="setting"
            onClick={() => this.handleSetVisible(true)}
            disabled={!accountInfo.isIncubatorMng}
          >
            工位设置
          </Button>
          {config ? (
            <span>
              <Button
                icon="plus"
                onClick={() => this.handleAddVisible(true)}
                disabled={!accountInfo.isIncubatorMng}
              >
                新增工位
              </Button>
              <Button
                icon="minus"
                disabled={!accountInfo.isIncubatorMng}
                onClick={() => this.handleDeleteVisible(true)}
              >
                删减工位
              </Button>
              <Popconfirm
                visible={uuids.length > 0 && op === 'disable'}
                onConfirm={this.handleDisable}
                onCancel={() => this.setOp('')}
                title="确认禁用选中工位？"
                disabled
              >
                <Button
                  icon="minus-circle"
                  disabled={
                    uuids.length < 1 ||
                    (disableLen && uuids.length <= disableLen) ||
                    !accountInfo.isIncubatorMng
                  }
                  onClick={() => {
                    this.setOp('disable');
                  }}
                >
                  禁用工位
                </Button>
              </Popconfirm>
              <Popconfirm
                onConfirm={this.handleEnable}
                title="确认启用选中工位？"
                onCancel={() => this.setOp('')}
                visible={uuids.length > 0 && op === 'enable'}
              >
                <Button
                  icon="minus-circle"
                  disabled={uuids.length < 1 || !disableLen || !accountInfo.isIncubatorMng}
                  onClick={() => {
                    this.setOp('enable');
                  }}
                >
                  启用工位
                </Button>
              </Popconfirm>
              <Button
                icon="property-safety"
                onClick={() => this.handleUnitVisible(true)}
                disabled={uuids.length < 1 || !accountInfo.isIncubatorMng}
              >
                单价设置
              </Button>
              <Popconfirm
                onConfirm={this.handleReset}
                title="确认重置选中工位？"
                onCancel={() => this.setOp('')}
                visible={uuids.length > 0 && op === 'reset'}
              >
                <Button
                  icon="reload"
                  disabled={uuids.length < 1 || !accountInfo.isIncubatorMng}
                  onClick={() => {
                    this.setOp('reset');
                  }}
                >
                  重置工位
                </Button>
              </Popconfirm>
              <Button icon="export" onClick={this.createPic} disabled={!accountInfo.isIncubatorMng}>
                导出工位
              </Button>
            </span>
          ) : null}
        </div>
        <ComSeatTable
          {...this.props}
          incubatorUuid={this.props.params.uuid}
          handleChange={this.handleChange}
          ref={node => {
            this.seatTable = node;
          }}
        />
        {addVisible ? (
          <SeatAdd
            onCancel={() => this.handleAddVisible(false)}
            handleSubmit={this.handleAdd}
            title="新增工位"
          />
        ) : null}
        {deleteVisible ? (
          <SeatAdd
            onCancel={() => this.handleDeleteVisible(false)}
            handleSubmit={this.handleDelete}
            title="删减工位"
          />
        ) : null}

        {setVisible ? (
          <SeatSet
            onCancel={() => this.handleSetVisible(false)}
            handleSet={this.handleSet}
            config={config || {}}
          />
        ) : null}
        {unitVisible ? (
          <SeatUnit onCancel={() => this.handleUnitVisible(false)} handleSet={this.handleUnit} />
        ) : null}
      </div>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Index);



// WEBPACK FOOTER //
// ./src/components/incubator/seat/Index.js